import type {ReactElement} from 'react';
import {useEffect, useState} from 'react';
import {MOBILE_MODAL_WIDTH_THRESHOLD, Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import type {CreateSignupFormPanelProps} from '@Panels/create-signup-form-panel';
import {CREATE_SIGNUP_FORM_PANEL_ID} from '@Modals/create-signup-form-modal/index';
import useWindowSize from '@Hooks/useWindowSize';
import {useAppSelector} from '@/hooks';

export type CreateSignupFormModalProps = CreateSignupFormPanelProps;

export default function CreateSignupFormModal(): ReactElement<any> | null {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.CREATE_SIGNUP_FORM_MODAL];
  });
  const isPanelLoading = useAppSelector((state) => {
    return state.lazyPanels.lazyPanelHashmap[CREATE_SIGNUP_FORM_PANEL_ID]?.isLoading ?? false;
  });
  const [height, setHeight] = useState<string>('');
  const [width, setWidth] = useState<string>('');
  const {windowWidth} = useWindowSize();

  const isMobileModal = windowWidth < MOBILE_MODAL_WIDTH_THRESHOLD;

  useEffect(() => {
    if (isPanelLoading) {
      setHeight('542px');
      setWidth(isMobileModal ? '100%' : '500px');
    } else {
      setHeight('auto');
      if (isMobileModal) {
        setWidth('100%');
      } else {
        setWidth('');
      }
    }
  }, [isPanelLoading]);

  const mobileMaxWidth = `${MOBILE_MODAL_WIDTH_THRESHOLD}px`;

  return (
    <Modal
      modalId={MODALS_IDS.CREATE_SIGNUP_FORM_MODAL}
      panelId={CREATE_SIGNUP_FORM_PANEL_ID}
      modalMaxWidth={isMobileModal ? mobileMaxWidth : ''}
      modalWidth={width}
      modalHeight={height}
      noBorder
    >
      <LazyPanel
        lazyPanelId={CREATE_SIGNUP_FORM_PANEL_ID}
        panelDirectoryName="create-signup-form-panel"
        panelProps={{
          ...modalData.panelProps,
          panelId: CREATE_SIGNUP_FORM_PANEL_ID,
        }}
      />
    </Modal>
  );
}
